import {
  Box,
  Button,
  Grid,
  Link,
  Typography,
} from '@mui/material'

const CARD_BACKGROUND = {
  highlight: 'linear-gradient(to bottom, rgb(62, 178, 158, 40%), transparent)',
  shadow: 'linear-gradient(to bottom, rgb(62, 178, 158, 10%), transparent)',
}

const withCta = (element, cta) => cta ? (
  <Link
    href={cta.href}
    underline="none"
    color="inherit"
  >
    {element}
  </Link>
) : element

const FeatureCard = ({
  variant = 'shadow',
  cta,
  content,
  icon,
  image,
  imagePosition = 'center',
  title,
}) => {
  const body = content.map((paragraph, index) => (
    <Typography
      key={index}
      sx={{ mt: 2 }}
      variant="body2"
    >
      {paragraph}
    </Typography>
  ))
  const ctaButton = cta && (
    <Button
      href={cta.href}
      variant="contained"
      sx={{ mt: 4 }}
    >
      {cta.label}
    </Button>
  )
  const background = CARD_BACKGROUND[variant]

  const imageElement = image && (
    <Box
      component="img"
      src={image}
      alt={title}
      sx={{
        display: 'block',
        width: '100%',
        height: 200,
        objectFit: 'cover',
        objectPosition: imagePosition,
        maskImage: 'linear-gradient(to bottom, black 70%, transparent 100%)',
      }}
    />
  )
  const titleElement = (
    <Typography variant="h4" sx={{ mt: 3, fontSize: { xs: 22, sm: 24 } }}>
      {title}
    </Typography>
  )

  return (
    <Grid item
      lg={4}
      md={6}
      xs={12}
    >
      <Box
        sx={{
          background,
          borderRadius: '20px',
          overflow: 'hidden',
          textAlign: 'center',
        }}
      >
        {imageElement && withCta(imageElement, cta)}
        <Box sx={{ pt: image ? 0 : 5, pb: 5, px: 3 }}>
          {icon}
          {withCta(titleElement, cta)}
          {body}
          {ctaButton}
        </Box>
      </Box>
    </Grid>
  )
}

export default FeatureCard
